<template>
    <v-dialog v-model="show" max-width="50%" :dark="darkMode">
        <v-card >
          <v-card-title>
            <span class="text-h5">{{title}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-form @submit.prevent="$emit('setQName',tempQName)">
                    <v-autocomplete
                    outlined hide-details
                    label="QDigit or QCode or QName" :placeholder="qname"
                    :items="show?history:[]"
                    hide-no-data
                    append-icon=""
                    :search-input.sync="tempQName"
                    @keydown.enter="$emit('setQName',tempQName)"
                    >
                    </v-autocomplete>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  color="primary" @click="$emit('setQName',tempQName)">Confirm</v-btn>
            <v-btn  @click="tempQName='';show=false;">Cancel</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name:'SetQNameDialog',
    props:['visible','title','history','qname','darkMode'],
    data(){
        return {
            tempQName:''
        }
    },
    computed: {
    show: {
      get () {
        return this.visible;
      },
      set (value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  },
  watch:{
  }

}
</script>
